export default __webpack_public_path__ + "static/media/ice-cube.7e45b73b.svg";